window._ = require('lodash');


try {
    global.$ = global.jQuery = window.$ = window.jQuery = require('jquery');
    require('form-serializer');
    require('bootstrap');
} catch (e) {
    console.error(e);
}

require('owl.carousel');
require('@fancyapps/fancybox');
require('jquery-ui');
require('jquery-ui/ui/widgets/slider');
require('jquery-match-height');
require('rateyo');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}


// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js